module.exports = __webpack_public_path__ + "img/active.818376f7.png";